import { type ComponentType, useContext } from "react";

import { createComponentPluginsContext } from "../convenience/plugins";

export interface WorkoutPlugins {
  comments: ComponentType<{
    workoutItemId: string;
    selectedWorkoutItemChildId: string | null;
    exerciseId?: string;
  }>;
  history?: ComponentType<{ workoutItemId: string; exerciseId?: string }>;
}

export const workoutPluginsContext =
  createComponentPluginsContext<WorkoutPlugins>();

export function useWorkoutPlugins() {
  return useContext(workoutPluginsContext).plugins;
}
